import { useListGraphEntities } from '@squareup/dex-feature-hooks-graph';
import { EntityPageContent } from '@squareup/dex-tech-entity-page-content';
import { getNextPublicApiReferenceNameOrDefault } from '@squareup/dex-utils-environment';
import { filterForValidGraphEnums } from '@squareup/dex-utils-oas';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React, { ReactNode, useMemo } from 'react';

import { SquareVersionPage } from '../../../../shared/SquareVersionPage';

const PageContent = () => {
  const { entities } = useListGraphEntities();
  const params = useParams();

  const filteredEntities = useMemo(
    () => filterForValidGraphEnums(entities),
    [entities]
  );

  const title = `Enums Index - ${getNextPublicApiReferenceNameOrDefault()}`;

  return (
    <EntityPageContent
      description="List of all enums in the Square API."
      entities={filteredEntities}
      title={title}
      type="enum"
      currentVersion={params?.square_version as string}
    />
  );
};

class Page extends SquareVersionPage {
  public static override routeHandlerName = '[square_version]/enums';

  protected override getPageContent(): ReactNode {
    return super.getPageContent({
      children: <PageContent />,
    });
  }
}

export default Page;
